import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import FluxoSolicitacaoTAStore from "./FluxoSolicitacaoTAStore";
import moment from "moment/moment";

export default class AndamentoTAStore extends FluxoSolicitacaoTAStore {

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
    }

    getSolicitacao(dadosUrl) {
        const solicitacaoEttId = dadosUrl.solicitacaoEttId;
        const terminoAntecipadoId = parseInt(dadosUrl.terminoAntecipadoId.replace("TA", ""));
        const idFluxo = dadosUrl.idFluxo;

        this.nomeFluxo = "solicitacaoTerminoAntecipado";
        this.nomeTarefa = "HT_AvaliacaoSolicitacaoGestor";
        this.loadingPanelStore.setIsLoading("AndamentoTALoading", true);

        this.idFluxo = idFluxo;

        let promise = (this.idFluxo !== undefined) 
                        ? this.fluxoService.carregarDetalhesSolicitacaoByTerminoAntecipadoId(solicitacaoEttId, terminoAntecipadoId)
                        : this.solicitacaoService.carregarDetalhesSolicitacaoByTerminoAntecipadoId(solicitacaoEttId, terminoAntecipadoId);

        promise.then(response => {

            this.handleSolicitacaoPorId(response.data.solicitacao, !!dadosUrl.solicitacaoEttId, false);
            this.handleSolicitacaoEttById(response.data.solicitacaoEtt, false, terminoAntecipadoId);
            this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);

            this.solicitacaoMudancaPrazo = response.data.solicitacaoMudancaPrazo;
            if(_.get(this.solicitacaoMudancaPrazo, "dataTerminoProrrogada")) {
                this.momentDataTerminoAntecipado = moment(this.solicitacaoMudancaPrazo.dataTerminoProrrogada);
                this.setDataTerminoAntecipado(this.momentDataTerminoAntecipado);
            } else {
                this.momentDataTerminoAntecipado = null;
            }

            this.carregarDadosProrrogacoesAnteriores();

            this.loadingPanelStore.setIsLoading("AndamentoTALoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("AndamentoTALoading", false);
        });
    }
}